// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SharingSection-container-zO2Yw {
	width: 100%;
	max-width: var(--max-content-width);
	margin: 0 auto;
	padding: 0 20px;
}

.SharingSection-easyImage-SsFfo {
	padding: 90px 0 0px;
}

.SharingSection-heading-NYkEB {
	font-size: 48px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: center;
}

.SharingSection-desc-Vz6gf {
	font-size: 18px;
	text-align: center;
	margin: 0 0 38px;
}

/** RentAll - Begin **/

.SharingSection-whybnb-KyJqm {
	padding-top: 15px;
	margin-bottom: 84px;
}

h4.SharingSection-common-e9aT1 {
	font-size: 24px;
	font-weight: 800;
	text-align: center;
	margin-bottom: 10px;
}

p.SharingSection-common-e9aT1 {
	font-size: 16px;
	line-height: 1.7;
	text-align: center;
	font-weight: 400;
}

.SharingSection-whybnb-KyJqm .SharingSection-whyblock-VZvWJ {
	padding-right: 45px;
}

.SharingSection-whiteBox-teRDH {
	background-color: var(--primary-white-bg);
	padding: 40px 36px 36px;
	-webkit-box-shadow: 0px 10px 21px #BFBFBF24;
	        box-shadow: 0px 10px 21px #BFBFBF24;
	border-radius: 6px;
}

.SharingSection-grayText-ySaoi {
	color: var(--muted-text-color);
}

.SharingSection-iconCss-ZDtXZ {
	width: 100%;
	max-width: 55px;
}

.SharingSection-gap-YCep9 {
	gap: 12px;
}

.SharingSection-arrowCenter-p4jeh {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-top: 24px;
}

.SharingSection-displayInline-yMtIU {
	cursor: pointer;
}

.SharingSection-btnCss-gwR7w,
.SharingSection-btnCss-gwR7w:hover,
.SharingSection-btnCss-gwR7w:focus,
.SharingSection-btnCss-gwR7w:active,
.SharingSection-btnCss-gwR7w:active:hover {
	-webkit-box-shadow: 0px 21px 41px #31313126 !important;
	        box-shadow: 0px 21px 41px #31313126 !important;
}

.SharingSection-flexCenter-OAF53 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.SharingSection-shareIconCss-YXoTY {
	width: 26px;
}

@media screen and (max-width: 991px) {
	.SharingSection-whybnb-KyJqm {
		padding-top: 45px;
		margin-bottom: 0px;
	}

	h4.SharingSection-common-e9aT1 {
		font-size: 23px;
		font-weight: 600;
	}

	.SharingSection-whyblock-VZvWJ {
		margin-bottom: 85px;
		padding-right: 0px !important;
		padding-left: 0px;
	}

	.SharingSection-mainhedding-C0Lf9 h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 13px;
	}
}

@media screen and (max-width: 767px) {
	.SharingSection-whybnb-KyJqm {
		margin-top: 0px;
		margin-bottom: 0px;
	}

	.SharingSection-common-e9aT1 {
		font-size: 23px;
		font-weight: 600;
	}

	.SharingSection-whyblock-VZvWJ {
		margin-bottom: 35px;
		padding-right: 0px;
		padding-left: 0px;
	}

	.SharingSection-mainhedding-C0Lf9 h1 {
		font-size: 32px;
		line-height: 51px;
		text-align: left;
		margin-bottom: 5px;
		text-align: left;
		padding-left: 15px;
		padding-right: 15px;
	}

	.SharingSection-steps-GErFT {
		margin-top: 24px;
	}

	h4.SharingSection-common-e9aT1 {
		font-size: 20px;
	}

	p.SharingSection-common-e9aT1 {
		font-size: 14px;
		line-height: 1.7;
		font-weight: 400;
	}
}

@media (max-width: 450px) {
	.SharingSection-heading-NYkEB {
		font-size: 30px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/SharingSection/SharingSection.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA,sBAAsB;;AAEtB;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yCAAyC;CACzC,uBAAuB;CACvB,2CAAmC;SAAnC,mCAAmC;CACnC,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;;CAKC,sDAA8C;SAA9C,8CAA8C;AAC/C;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\tpadding: 0 20px;\n}\n\n.easyImage {\n\tpadding: 90px 0 0px;\n}\n\n.heading {\n\tfont-size: 48px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: center;\n}\n\n.desc {\n\tfont-size: 18px;\n\ttext-align: center;\n\tmargin: 0 0 38px;\n}\n\n/** RentAll - Begin **/\n\n.whybnb {\n\tpadding-top: 15px;\n\tmargin-bottom: 84px;\n}\n\nh4.common {\n\tfont-size: 24px;\n\tfont-weight: 800;\n\ttext-align: center;\n\tmargin-bottom: 10px;\n}\n\np.common {\n\tfont-size: 16px;\n\tline-height: 1.7;\n\ttext-align: center;\n\tfont-weight: 400;\n}\n\n.whybnb .whyblock {\n\tpadding-right: 45px;\n}\n\n.whiteBox {\n\tbackground-color: var(--primary-white-bg);\n\tpadding: 40px 36px 36px;\n\tbox-shadow: 0px 10px 21px #BFBFBF24;\n\tborder-radius: 6px;\n}\n\n.grayText {\n\tcolor: var(--muted-text-color);\n}\n\n.iconCss {\n\twidth: 100%;\n\tmax-width: 55px;\n}\n\n.gap {\n\tgap: 12px;\n}\n\n.arrowCenter {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 24px;\n}\n\n.displayInline {\n\tcursor: pointer;\n}\n\n.btnCss,\n.btnCss:hover,\n.btnCss:focus,\n.btnCss:active,\n.btnCss:active:hover {\n\tbox-shadow: 0px 21px 41px #31313126 !important;\n}\n\n.flexCenter {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.shareIconCss {\n\twidth: 26px;\n}\n\n@media screen and (max-width: 991px) {\n\t.whybnb {\n\t\tpadding-top: 45px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.whyblock {\n\t\tmargin-bottom: 85px;\n\t\tpadding-right: 0px !important;\n\t\tpadding-left: 0px;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 13px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.whybnb {\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\t.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.whyblock {\n\t\tmargin-bottom: 35px;\n\t\tpadding-right: 0px;\n\t\tpadding-left: 0px;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 32px;\n\t\tline-height: 51px;\n\t\ttext-align: left;\n\t\tmargin-bottom: 5px;\n\t\ttext-align: left;\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.steps {\n\t\tmargin-top: 24px;\n\t}\n\n\th4.common {\n\t\tfont-size: 20px;\n\t}\n\n\tp.common {\n\t\tfont-size: 14px;\n\t\tline-height: 1.7;\n\t\tfont-weight: 400;\n\t}\n}\n\n@media (max-width: 450px) {\n\t.heading {\n\t\tfont-size: 30px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SharingSection-container-zO2Yw`,
	"easyImage": `SharingSection-easyImage-SsFfo`,
	"heading": `SharingSection-heading-NYkEB`,
	"desc": `SharingSection-desc-Vz6gf`,
	"whybnb": `SharingSection-whybnb-KyJqm`,
	"common": `SharingSection-common-e9aT1`,
	"whyblock": `SharingSection-whyblock-VZvWJ`,
	"whiteBox": `SharingSection-whiteBox-teRDH`,
	"grayText": `SharingSection-grayText-ySaoi`,
	"iconCss": `SharingSection-iconCss-ZDtXZ`,
	"gap": `SharingSection-gap-YCep9`,
	"arrowCenter": `SharingSection-arrowCenter-p4jeh`,
	"displayInline": `SharingSection-displayInline-yMtIU`,
	"btnCss": `SharingSection-btnCss-gwR7w`,
	"flexCenter": `SharingSection-flexCenter-OAF53`,
	"shareIconCss": `SharingSection-shareIconCss-YXoTY`,
	"mainhedding": `SharingSection-mainhedding-C0Lf9`,
	"steps": `SharingSection-steps-GErFT`
};
module.exports = ___CSS_LOADER_EXPORT___;
